import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Button from "@ingka/button";
import { Divider } from "./Divider";
import searchIcon from "@ingka/ssr-icon/paths/magnifying-glass";
const SearchButton = ({ prefix, baseClass, text, onClick, hidden }) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(Divider, { baseClass, hidden }),
  /* @__PURE__ */ jsx(
    Button,
    {
      prefix,
      htmlType: "submit",
      type: "tertiary",
      className: `${baseClass}__action`,
      xsmallIconOnly: true,
      iconOnly: true,
      ssrIcon: searchIcon,
      text,
      onClick,
      "aria-hidden": hidden,
      disabled: hidden
    }
  )
] });
export {
  SearchButton
};
